import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL
// const GET_AGENT_URL = `${API_URL}/agent/actives`
const PROJECT_URL = `${API_URL}/project`
const GEOFENCING_URL = `${API_URL}/geofencing`
const GEOFENCELOGS_URL = `${API_URL}/geofencinglogs`

// export async function getAgent(): Promise<any> {
//   try {
//     const response: AxiosResponse<any> = await axios.get(`${GET_AGENT_URL}`)
//     return response.data
//   } catch (error) {
//     // Handle errors here
//     console.error('Add Client error:', error)
//     throw error
//   }
// }

export async function getProject(): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.get(`${PROJECT_URL}`)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function postGeofencing(data: any): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.post(`${GEOFENCING_URL}`, data)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function getGeofencing(): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.get(`${GEOFENCING_URL}`)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function getGeofencingbyid(id: string): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.get(`${GEOFENCING_URL}/${id}`)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function getGeofencingbySurveyor(id: string): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.get(`${GEOFENCING_URL}/surveyor/${id}`)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function deleteGeofencing(id: string): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.delete(`${GEOFENCING_URL}/${id}`)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function postGeoFenceLog(data: any): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.post(
      `${GEOFENCELOGS_URL}/${data.geoFenceId}/geofence`,
      data
    )
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}

export async function getGeofenceLogsbyid(id: string): Promise<any> {
  try {
    const response: AxiosResponse<any> = await axios.get(`${GEOFENCELOGS_URL}/${id}/geofence`)
    return response.data
  } catch (error) {
    // Handle errors here
    console.error('Add Client error:', error)
    throw error
  }
}
